import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { t } from '@configuratorware/configurator-frontendgui/Framework/i18n';
import withWidth from '@material-ui/core/withWidth/withWidth';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography/Typography';
import CheckCircle from '@material-ui/icons/CheckCircle';
import FileCopy from '@material-ui/icons/FileCopy';
import Error from '@material-ui/icons/Error';
import MainButton from '@configuratorware/configurator-frontendgui/Shared/Components/MainButton';
import CustomDialog from '@configuratorware/configurator-frontendgui/Shared/Components/CustomDialog';
import PropTypes from 'prop-types';
import Tooltip from '@material-ui/core/Tooltip/Tooltip';
import Icon from '@material-ui/core/Icon/Icon';
import {
  LoadDarkIcon,
} from '../../../../Icons';

const styles = (theme) => ({
  dialogTitleRoot: {
    padding: '12px 12px 20px',
    fontSize: '1.5rem',
    fontWeight: 400,
  },
  dialogContentRoot: {
    padding: '0 24px 0 12px',
  },
  saveconfigurationDialog: {
    borderTop: `7px solid ${theme.palette.primary.main}`,
  },
  activeButton: {
    padding: '6px 15px',
  },
  saveConfigurationCode: {
    textAlign: 'center',
    marginTop: 24,
    marginBottom: 48,
    height: 40,
    fontSize: 24,
    lineHeight: '28px',
    [theme.breakpoints.down('xs')]: {
      height: 56,
      marginBottom: 32,
    },
  },
  TypographyCaption: {
    fontSize: 12,
    lineHeight: 1.7,
  },
  TypographyInfoLoadConfig: {
    fontSize: 12,
    lineHeight: 2,
    marginLeft: 5,
    display: 'flex',
    alignItems: 'center',

  },
  TypographyInfoLoadConfigText: {
    fontSize: 12,
    lineHeight: 1,
    paddingLeft: 33,
    marginBottom: 15,

  },
  successResult: {
    background: '#4FC36D',
    color: '#fff',
    padding: '14px 8px',
    borderRadius: '4px',
  },
  successResultIcon: {
    float: 'left',
  },
  copyShareUrlIcon: {
    float: 'right',
    '&:hover': {
      color: 'rgba(0,0,0, 0.5)',
      cursor: 'pointer',
    },
  },
  errorResult: {
    background: '#ED1C29',
    color: '#fff',
    padding: '14px 8px',
    borderRadius: '4px',
    fontSize: 14,
    lineHeight: 1.7,
    textAlign: 'center',
  },
  errorResultIcon: {
    float: 'left',
  },
  dialogSavingInProgress: {
    flex: 1,
    alignItems: 'center',
    flexDirection: 'column',
    display: 'flex',
    height: 50,
    marginTop: 24,
  },
  infoHeading: {
    marginLeft: 5,
  },
  infoText: {
    marginRight: 5,
  },
  load: {
    position: 'relative',
    top: 3,
  },
});

class SaveConfiguration extends React.Component {
    static propTypes = {
      classes: PropTypes.object,
      workInProgress: PropTypes.bool,
      errorMessage: PropTypes.string,
      code: PropTypes.string,
      loadLoginInfoInProgress: PropTypes.bool,
      show: PropTypes.bool,
      onClose: PropTypes.func,
      onOkClick: PropTypes.func,
      ProgressComponent: PropTypes.func,
      shareUrl: PropTypes.string,
      IconCopyShareUrl: PropTypes.object,
    };

    static defaultProps = {
      IconCopyShareUrl: FileCopy,
    };

    onCopyShareUrl = (shareUrl) => {
      try {
        navigator.clipboard.writeText(shareUrl);
      } catch (err) {
        // clipboard api only available in secure contexts (localhost, htttps) and modern(ish) browsers
        const textArea = document.createElement('textarea');
        textArea.textContent = shareUrl;
        textArea.style.position = 'fixed'; // avoid scrolling to bottom
        document.body.appendChild(textArea);
        const selection = document.getSelection();
        const range = document.createRange();
        range.selectNode(textArea);
        selection.removeAllRanges();
        selection.addRange(range);
        try {
          document.execCommand('copy');
        } catch (err) {
          // eslint-disable-next-line no-console
          console.log('Configuration link could not be copied: ', err);
        } finally {
          selection.removeAllRanges();
          document.body.removeChild(textArea);
        }
      }
    };

    render() {
      const {
        classes,
        workInProgress,
        errorMessage,
        code,
        loadLoginInfoInProgress,
        show,
        onClose,
        onOkClick,
        ProgressComponent,
        shareUrl,
        IconCopyShareUrl,
      } = this.props;
      return (
        <CustomDialog
          open={show}
          onClose={onClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          onCancel={onClose}
          dialogTitle={t('saveConfiguration.dialogTitle')}
        >
          <DialogContent className={classes.dialogContentRoot}>
            {workInProgress && (
            <div className={classes.dialogSavingInProgress}>
              <ProgressComponent />
            </div>
            )}
            {errorMessage && (
            <Typography
              variant="body1"
              classes={{
                root: classes.TypographyCaption,
              }}
              id="alert-dialog-description"
            >
              <div className={classes.errorResult}>
                <Error className={classes.errorResultIcon} />
                {t(errorMessage)}
              </div>
            </Typography>
            )}
            {!workInProgress && code && (
            <>
              <Typography
                variant="body1"
                classes={{ root: classes.TypographyCaption }}
                id="alert-dialog-description"
              >
                {t('saveConfiguration.successfullySaved')}
              </Typography>

              <Typography
                variant="body1"
                classes={{ root: classes.TypographyCaption }}
                id="alert-dialog-description"
              >
                {t('saveConfiguration.infoText')}
              </Typography>
              <Typography
                id="alert-dialog-description"
                variant="h5"
                classes={{ root: classes.saveConfigurationCode }}
              >
                <div className={classes.successResult}>
                  <CheckCircle className={classes.successResultIcon} />
                  <b>{code}</b>
                  {IconCopyShareUrl && (
                  <Tooltip title={t('saveConfiguration.copyConfigurationLink')}>
                    <IconCopyShareUrl
                      className={classes.copyShareUrlIcon}
                      onClick={() => this.onCopyShareUrl(shareUrl)}
                    />
                  </Tooltip>
                  )}
                </div>

              </Typography>
              <Typography
                variant="body1"
                classes={{ root: classes.TypographyInfoLoadConfig }}
              >
                <Icon>info</Icon>
                <span className={classes.infoHeading}>{t('saveConfiguration.infoLoadConfigHeading')}</span>
              </Typography>
              <Typography
                variant="body1"
                classes={{ root: classes.TypographyInfoLoadConfigText }}
              >
                <i className={classes.infoText}>{t('saveConfiguration.infoLoadConfig')}</i>
                <LoadDarkIcon className={classes.load} />
              </Typography>
              {loadLoginInfoInProgress && (
              <Typography
                variant="body1"
                classes={{ root: classes.TypographyCaption }}
                id="alert-dialog-description"
              >
                {t('saveConfiguration.loadLoginInfoInProgressText')}
              </Typography>
              )}

            </>
            )}
          </DialogContent>
          <DialogActions>
            {!workInProgress && code && (
            <MainButton
              onClick={onOkClick}
              variant="contained"
              size="medium"
              className={classes.activeButton}
            >
              {t('saveConfiguration.okText')}
            </MainButton>
            )}
          </DialogActions>
        </CustomDialog>
      );
    }
}

export default withWidth()(withStyles(styles, { name: 'SaveConfiguration' })(SaveConfiguration));
